import React, { createContext, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addBlueItem,
  removeBlueItem,
  updateBlueQuantity,
  updateBlueNotes,
  updateBlueConfiguration,
  setBlueStatus,
  blueSubmitSucceeded,
  clearBlueCart,
  selectBlueCart,
  selectBlueItemCount,
} from '../store/slices/blueCartSlice';

const BlueCartContext = createContext(null);

export function BlueCartProvider({ children }) {
  return <BlueCartContext.Provider value={true}>{children}</BlueCartContext.Provider>;
}

export function useBlueCart() {
  const dispatch = useDispatch();
  const cart = useSelector(selectBlueCart);
  const itemCount = useSelector(selectBlueItemCount);

  return {
    items: cart.items,
    status: cart.status,
    itemCount,
    // Add a NEW line item (always a new entry — multiple configs per product allowed)
    addItem: (product, quantity = 1, configuration = {}, notes = '') =>
      dispatch(addBlueItem(product, quantity, configuration, notes)),
    // Remove by cartItemId
    removeItem: (cartItemId) => dispatch(removeBlueItem(cartItemId)),
    // Update quantity by cartItemId
    updateQuantity: (cartItemId, quantity) =>
      dispatch(updateBlueQuantity({ cartItemId, quantity })),
    updateNotes: (cartItemId, notes) =>
      dispatch(updateBlueNotes({ cartItemId, notes })),
    updateConfiguration: (cartItemId, configuration) =>
      dispatch(updateBlueConfiguration({ cartItemId, configuration })),
    setStatus: (status) => dispatch(setBlueStatus(status)),
    submitSucceeded: (orderId) => dispatch(blueSubmitSucceeded({ orderId })),
    clearCart: () => dispatch(clearBlueCart()),
  };
}
